import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { CloseIcon, ExitIcon, UsersOutlineIcon } from '@silbo/ui';
import { useTranslation } from 'react-i18next';
import { useAuthenticationContext } from '../../../contexts/AuthenticationContext/useAuthenticationContext';

type ProfileDialogProps = {
  open: boolean;
  onClose: () => void;
};

const ProfileDialog = ({ open, onClose }: ProfileDialogProps) => {
  const { logout, user, healthCenter } = useAuthenticationContext();
  const { t } = useTranslation('bed-management');

  return (
    <Dialog open={open} onClose={onClose} keepMounted={false}>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h2">{t('profileDialog.title')}</Typography>
          <IconButton onClick={onClose} edge="end">
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3}>
          <Paper sx={{ padding: 3, bgcolor: 'background.default' }} elevation={0}>
            <Stack direction="row" alignItems="center" gap={2}>
              <Avatar sx={{ width: 60, height: 60, bgcolor: 'danger.main' }}>
                <UsersOutlineIcon sx={{ fontSize: 32 }} />
              </Avatar>
              <Stack spacing={1}>
                <Typography fontWeight={600}>{user?.username}</Typography>
                <Typography variant="body2" color="secondary">
                  {healthCenter?.name}
                </Typography>
              </Stack>
            </Stack>
          </Paper>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button startIcon={<ExitIcon />} onClick={logout} variant="outlined">
          {t('profileDialog.logout')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProfileDialog;
